export default __webpack_public_path__ + "static/media/globe.3ce1d09a.svg";